import React, { useState, useEffect } from 'react'
import { Checkbox, Col, ControlLabel, Row, Table } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { budgetFormat } from '../../../utils/formatterUtil'
import { Controller, useForm } from 'react-hook-form'
import EditSelectCell from '../../../components/cell/EditSelectCell'
import { cloneDeep } from 'lodash-es'
import EditTextCell from '../../../components/cell/EditTextCell'
import { requiredFiled } from '../../../utils/ValidatorUtils'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import ManageDurableArticlesManageType from './ManageDurableArticlesManageType'

export default function ClosureRequestAssetTable({
  schema,
  loading,
  Controller,
  register,
  control,
  errors,
  setValue,
  getValues,
  setError,
  clearErrors,
  page = 0,
  displayLength = 0,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  onSelected = () => {},
  selectedItem,
  onSelectManageType,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  //const { register, handleSubmit, errors, control, getValues, setValue, clearErrors } = useForm()
  const [tableData, setTableData] = useState([])
  const [masterTableData, setMasterTableData] = useState([])
  const [selected, setSelected] = useState([])
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const [isSelectAll, setIsSelectAll] = useState()
  const [formSchema, setFormSchema] = useState()
  const [indeterminate, setIndeterminate] = useState(false)

  const [isRefash, setIsRefash] = useState(false)

  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const fs = localStorage.getItem('fontSize')

  useEffect(() => {
    // register('selectedItem', [])
    register('dataTable', [])
    setValue('dataTable', [])

    if (schema?.values?.length > 0) {
      schema.values.map((item) => {
        Object.assign(item, { status: 'EDIT', checked: false })
      })

      setTableData(schema.values)
    } else {
      setTableData([])
    }
    setFormSchema(schema)
    // console.log('isSelectAll ', isSelectAll)
    // isSelectAll && handleCheckAll(null, true)
  }, [schema.values])

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => {
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  const handleCheckAll = (value, checked) => {
    let newArr = []
    const checkedKeys = checked ? tableData.map((item) => item.id) : []
    tableData.map((item) => {
      // if (item.assetStatusCode == '0') {
      newArr.push(item.id)
      // }
    })
    setCheckedKeys(checkedKeys)
    setCountSelected(newArr.length)
    validCheked('MULTI', value, checked)
  }

  const handleCheck = (value, checked) => {
    const nextCheckedKeys = checked
      ? [...checkedKeys, value]
      : checkedKeys.filter((item) => item !== value)

    validCheked('ONE', value, checked)
    setCheckedKeys(nextCheckedKeys)
    setCountSelected(nextCheckedKeys.length)
  }

  const validCheked = (type, data, checked) => {
    let datas = cloneDeep(tableData)
    // console.log('data ', data)
    // console.log('checked ', checked)

    if (type == 'ONE') {
      datas.map((item) => {
        if (data == item.id) {
          item.checked = checked
        }
      })
    }

    if (type == 'MULTI') {
      datas.map((item) => {
        item.checked = checked
      })
    }

    setTableData(datas)
    setValue('dataTable', datas)
  }

  const onChangeTableValue = (index, value, key, id) => {
    let datas = cloneDeep(tableData)

    datas[index][key] = value

    // if (id) {
    //   handleCheck(id, !!value)
    // }

    setValue('dataTable', datas)
    setTableData(datas)

    onSelectManageType([...new Set(datas?.map((item) => item.closureType))])
  }

  const onChangeTableValueAll = (value, key) => {
    let datas = cloneDeep(tableData)

    datas?.forEach((item) => {
      if (checkedKeys?.includes(item.id)) {
        item[key] = value
      }
    })

    setValue('dataTable', datas)
    setTableData(datas)

    console.log('datas : ', datas)

    onSelectManageType([...new Set(datas?.map((item) => item.closureType))])
    onRefash()
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      {checkedKeys?.length > 0 && formSchema.closureType && (
        <>
          <div style={{ marginTop: -10 }}>
            <ManageDurableArticlesManageType
              schema={formSchema}
              onApply={(data) => {
                onChangeTableValueAll(
                  data[formSchema.closureType.name],
                  formSchema.closureType.name
                )
              }}
            />
          </div>
        </>
      )}

      {!isRefash && (
        <>
          <Table
            wordWrap
            minHeight={300}
            rowHeight={80}
            autoHeight
            loading={loading}
            headerHeight={fs <= 15 ? undefined : fs < 16 ? 70 : fs <= 18 ? 75 : 80}
            data={tableData}
            style={{ marginTop: '20px' }}
            bordered
            cellBordered
          >
            <Column width={100} align="center">
              <HeaderCell style={{ padding: 0 }}>
                <div style={{ lineHeight: '40px' }}>
                  <Controller
                    name="chkRow"
                    control={control}
                    render={(props) => {
                      // if (isEditMode) {
                      //   return 'ลำดับ'
                      // }
                      return (
                        <Checkbox
                          inline
                          checked={props.value}
                          indeterminate={indeterminate}
                          onChange={(e, checked) => {
                            props.onChange(checked)
                            // console.log('checked ', checked)
                            setIsSelectAll(checked)
                            handleCheckAll(null, checked)
                          }}
                        >
                          <b>ลำดับ</b>
                        </Checkbox>
                      )
                    }}
                  />
                </div>
              </HeaderCell>

              <CheckCell
                dataKey="id"
                checkedKeys={checkedKeys}
                onChange={(value, checked) => {
                  console.log('checked ', checked)
                  setIsSelectAll(false)
                  handleCheck(value, checked)
                }}
              />
            </Column>

            <Column width={180}>
              <HeaderCell style={styleHeaderCell}>รหัสครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetCode" />
            </Column>

            <Column width={250} minWidth={250} flexGrow={1}>
              <HeaderCell>ชื่อครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetName" />
            </Column>

            <Column width={230}>
              <HeaderCell>ประเภทครุภัณฑ์</HeaderCell>
              <Cell dataKey="assetType" />
            </Column>

            <Column width={120} align="right">
              <HeaderCell>ราคา/หน่วย</HeaderCell>
              <Cell>
                {(rowData) => {
                  return budgetFormat(rowData.price)
                }}
              </Cell>
            </Column>

            <Column width={180} align="center" fixed={'right'}>
              <HeaderCell>รูปแบบบริหารจัดการ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  // console.log('row data => ', index, rowData)
                  // if (!rowData.isDeletable || rowData.status != 'EDIT') {
                  //   return rowData.bankAccountName
                  // }

                  if (rowData?.checked) {
                    return (
                      <EditSelectCell
                        id={`${formSchema.closureType.name}_${rowData.id}`}
                        //id={`table[${index}].${schema.activity.name}`}
                        rowData={rowData}
                        rowSchema={formSchema.closureType}
                        dataKey={formSchema.closureType.name}
                        register={register}
                        control={control}
                        errors={errors}
                        cleanable={true}
                        searchable={true}
                        onChangeCell={(value) =>
                          onChangeTableValue(index, value, formSchema.closureType.name, rowData.id)
                        }
                      />
                    )
                  }

                  return ''
                }}
              </Cell>
            </Column>
          </Table>
          {/* <TablePagination
        // disabled={isSelectAll}
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      /> */}
        </>
      )}
    </>
  )
}
